<template>
  <div class="row justify-content-center" >
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <div class="card-header bg-transparent pb-5">
          <div class="text-muted text-center mt-2 mb-3">
            <small>Login com</small>
          </div>
          <div class="btn-wrapper text-center">
            <div id="fb-root"></div>
            <button class="loginBtn loginBtn--facebook" @click="facebookLogin">Facebook</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Store from "@/store/store";

export default {
  computed: {
    Store() {
      return Store
    }
  },
  methods: {
    async loadFacebookSDK(d, s, id) {
      return new Promise((resolve, reject) => {
        let js,
            fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
        js.onload = resolve;
        js.onerror = reject;
      });
    },
    async initFacebook() {
      return new Promise((resolve) => {
        window.fbAsyncInit = function () {
          window.FB.init({
            appId      : '942477520859124',
            cookie: true,
            xfbml: true,
            version    : 'v19.0'
          });
          resolve();
        };
      });
    },
    async facebookLogin() {
      const stor = this.$store
      const rou = this.$router
      window.FB.login(response => {
        if (response.authResponse) {
          const token = response.authResponse.accessToken
          window.FB.api('/me', function(response) {
            stor.commit('setName', response.name);
            stor.commit('setUserName', response.email);
            stor.commit('setAccessToken', token);
            stor.commit('setAuthentication', true);
            rou.push('/dashboard');
          });
        }
      }, {scope: 'email,public_profile', return_scopes: true});
      return false;
    }
  },
  async mounted() {
    if(Store.state.isAuthenticated){
      this.$router.push('/dashboard');
    }
    await this.loadFacebookSDK(document, "script", "facebook-jssdk");
    await this.initFacebook();
  }
}
</script>
<style>
/* Shared */
.loginBtn {
  box-sizing: border-box;
  position: relative;
  /* width: 13em;  - apply for fixed size */
  margin: 0.2em;
  padding: 0 15px 0 46px;
  border: none;
  text-align: left;
  line-height: 34px;
  white-space: nowrap;
  border-radius: 0.2em;
  font-size: 16px;
  color: #FFF;
}
.loginBtn:before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  width: 34px;
  height: 100%;
}
.loginBtn:focus {
  outline: none;
}
.loginBtn:active {
  box-shadow: inset 0 0 0 32px rgba(0,0,0,0.1);
}


/* Facebook */
.loginBtn--facebook {
  background-color: #4C69BA;
  background-image: linear-gradient(#4C69BA, #3B55A0);
  /*font-family: "Helvetica neue", Helvetica Neue, Helvetica, Arial, sans-serif;*/
  text-shadow: 0 -1px 0 #354C8C;
}
.loginBtn--facebook:before {
  border-right: #364e92 1px solid;
  background: url('https://s3-us-west-2.amazonaws.com/s.cdpn.io/14082/icon_facebook.png') 6px 6px no-repeat;
}
.loginBtn--facebook:hover,
.loginBtn--facebook:focus {
  background-color: #5B7BD5;
  background-image: linear-gradient(#5B7BD5, #4864B1);
}

</style>
